export const environment = {
  production: true,
  mapboxkey: 'pk.eyJ1IjoicmhpdGFlc3MiLCJhIjoiY2tjbDc1emsyMXE2ODJ4cXEyOXJ2OHZtMSJ9.g7Y_nTq2cpgtdq0ANhbxMw'
};
